// extracted by css-extract-rspack-plugin
export default {"bui-FieldLabelWrapper":"QCxpyIls6to9Bn5w","bui-FieldLabel":"qjnrgCeKosN0HGNG","bui-FieldSecondaryLabel":"VAD8KU3Enrs4kH_k","bui-FieldDescription":"KsFBKeDCTE86ZANx"};